// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2ZQB4","title":"InfoRow_title__3wTw0"};